// extracted by mini-css-extract-plugin
module.exports = {"container":"popularPlaces_container__pgty7","column":"popularPlaces_column__5NzOZ","places":"popularPlaces_places__PUtLx","category":"popularPlaces_category__bJM5b"};